import { createSlice } from "@reduxjs/toolkit";
import { subscribeApi } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const subscribeSlice = createSlice({
  name: "subscribe",
  initialState: data,
  reducers: {
    subscribeSlice(state) {
      state.isLoading = false;
    },
    subscribeSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    subscribeSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    subscribeSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const subscribeHandler = (data: any) => async (dispatch: any) => {
  try {
    dispatch(subscribeAction.subscribeSlice());
    const response: any = await subscribeApi(data);
    dispatch(subscribeAction.subscribeSliceSuccess(response));
  } catch (e: any) {
    dispatch(subscribeAction.subscribeSliceFailure(e?.response));
  }
};
export default subscribeSlice.reducer;
export const subscribeAction = subscribeSlice.actions;
